import { useEffect, useState } from 'react'

import { useTheme } from '@/components/theme/theme-provider'

import { cn } from '@/utils/cn'

interface Props {
    className?: string
}

export default function Logo({ className }: Props) {
    const { theme } = useTheme()
    const [appliedTheme, setAppliedTheme] = useState(theme)

    useEffect(() => {
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')

        const updateTheme = () => {
            const systemTheme = mediaQuery.matches ? 'dark' : 'light'
            const appliedTheme = theme === 'system' ? systemTheme : theme
            setAppliedTheme(appliedTheme)
        }

        updateTheme()
        mediaQuery.addEventListener('change', updateTheme)

        return () => mediaQuery.removeEventListener('change', updateTheme)
    }, [theme])

    const imgSrc = appliedTheme === 'dark' ? '/logo/dark-sm.png' : '/logo/light-sm.png'
    return (
        <div
            className={cn(
                'flex h-10 w-10 items-center justify-center rounded-sm border border-border bg-background',
                className,
            )}
        >
            <img src={imgSrc} className="h-6 w-6" />
        </div>
    )
}
